module.exports = __webpack_public_path__ + "img/golden-galleon.db6ab415.svg";